import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelBankAccountsEditResolverErrorStatesEnum {
    GetBankAccountFailed = ErrorStateScheduleEnum.PanelBankAccountsEditResolverErrorStatesStartIndex,
    BankAccountNotFound,
    GetClientFailed,
    ClientNotFound,
    GetCountriesFailed,
    GetCountriesInvalidData,
    GetCryptoCurrenciesFailed
}
